document.addEventListener('DOMContentLoaded', function() {
    // const supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;
    console.log('scroll init');
    document.querySelectorAll('[data-scroll-to]').forEach((anchor) => {
        console.log('anchor', anchor);
        const targetSelector = document.querySelector(anchor.dataset.scrollTo);
        console.log('target', targetSelector);
        if (targetSelector) {
            anchor.addEventListener('click', function (event) {
                event.preventDefault();
                window.scrollTo({
                    top: targetSelector.offsetTop,
                    behavior: 'smooth'
                });
            }, false);
        }
    })
});